import {
  Show,
  TextField,
  NumberField,
  DateField,
  FunctionField,
  Labeled,
  TabbedShowLayout,
} from 'react-admin';
import { Box, Typography } from '@mui/material';
import { NUMBER_FORMATS, DATETIME_FORMAT } from '../../utils';
import { TagPrintingsList } from './TagPrintingsList';
import { TagProgressBar } from './TagProgressBar';
import { Divider } from '../common';

export const TagShow = () => {
  return (
    <Show>
      <TabbedShowLayout>
        <TabbedShowLayout.Tab label="Details">
          <Box
            sx={{
              display: 'grid',
              gridTemplateColumns: {
                xs: '1fr',
                sm: 'repeat(2, 1fr)',
                md: 'repeat(3, 1fr)',
              },
              gap: 2,
              mt: 1,
            }}
          >
            <Labeled label="ID">
              <TextField source="id" />
            </Labeled>
            <Labeled label="Tag">
              <TextField source="tag" />
            </Labeled>
            <Labeled label="Created At">
              <DateField source="createdAt" showTime options={DATETIME_FORMAT} />
            </Labeled>
            <Labeled label="Material">
              <TextField source="material" />
            </Labeled>
            <Labeled label="Color">
              <TextField source="color" />
            </Labeled>
            <Labeled label="Profile">
              <TextField source="profileVersion" />
            </Labeled>
            <Labeled label="Total Weight">
              <NumberField source="weight" options={NUMBER_FORMATS.weight} />
            </Labeled>

            <Labeled label="Consumed">
              <NumberField source="consumedGrams" options={NUMBER_FORMATS.weight} />
            </Labeled>
            <Labeled label="Remaining">
              <FunctionField
                render={(record: { weight: number; consumedGrams: number }) => {
                  if (!record.weight) return '-';
                  const remaining = Number(record.weight) - Number(record.consumedGrams);
                  return `${remaining.toFixed(2)} g`;
                }}
              />
            </Labeled>
          </Box>
          <Divider spacing={3} />
          <Box sx={{ mb: 2 }}>
            <Typography variant="subtitle1" gutterBottom>
              Usage Statistics
            </Typography>
            <TagProgressBar />
          </Box>
        </TabbedShowLayout.Tab>
        <TabbedShowLayout.Tab label="Associated Printings">
          <TagPrintingsList />
        </TabbedShowLayout.Tab>
      </TabbedShowLayout>
    </Show>
  );
};
